import { IDanhSachHoanTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDanhSachHoanTotNghiepActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachHoanTotNghiepReducer } from "../../reducer-model/xet-tot-nghiep/IDanhSachHoanTotNghiepReducer";

const iniState: IDanhSachHoanTotNghiepReducer = {
    status: eReducerStatusBase.is_not_initialization,
    daThem: [],
    chuaThem: [],
};

export const danhSachHoanTotNghiepReducer = (state: IDanhSachHoanTotNghiepReducer = iniState, action: IDanhSachHoanTotNghiepActionTypes): IDanhSachHoanTotNghiepReducer => {
    switch (action.type) {
        case "DANH_SACH_HOAN_TOT_NGHIEP_SHOW_MODAL":
            return { ...state, isShowModal: true, dotSelected: action.payload };
        case "DANH_SACH_HOAN_TOT_NGHIEP_CLOSE_MODAL":
            return { ...state, isShowModal: false, dotSelected: undefined, daThem: [], chuaThem: [] };

        case "DANH_SACH_HOAN_TOT_NGHIEP_LOAD_DA_THEM_START":
        case "DANH_SACH_HOAN_TOT_NGHIEP_LOAD_CHUA_THEM_START":
            return { ...state, status: eReducerStatusBase.is_loading };
        case "DANH_SACH_HOAN_TOT_NGHIEP_LOAD_DA_THEM_SUCCESS":
            return { ...state, status: eReducerStatusBase.is_completed, daThem: action.payload };
        case "DANH_SACH_HOAN_TOT_NGHIEP_LOAD_CHUA_THEM_SUCCESS":
            return { ...state, status: eReducerStatusBase.is_completed, chuaThem: action.payload };
        case "DANH_SACH_HOAN_TOT_NGHIEP_LOAD_DA_THEM_ERROR":
        case "DANH_SACH_HOAN_TOT_NGHIEP_LOAD_CHUA_THEM_ERROR":
            return { ...state, status: eReducerStatusBase.is_completed };

        case "DANH_SACH_HOAN_TOT_NGHIEP_ADD_START":
        case "DANH_SACH_HOAN_TOT_NGHIEP_DELETE_START":
            return { ...state, status: eReducerStatusBase.is_saving };
        case "DANH_SACH_HOAN_TOT_NGHIEP_ADD_SUCCESS":
        case "DANH_SACH_HOAN_TOT_NGHIEP_DELETE_SUCCESS":
        case "DANH_SACH_HOAN_TOT_NGHIEP_ADD_ERROR":
        case "DANH_SACH_HOAN_TOT_NGHIEP_DELETE_ERROR":
            return { ...state, status: eReducerStatusBase.is_completed };

        default:
            return state;
    }
};
